import { render, staticRenderFns } from "./DeleteMessageButton.vue?vue&type=template&id=6ccf23c3&"
import script from "./DeleteMessageButton.vue?vue&type=script&lang=js&"
export * from "./DeleteMessageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports